import { Parse } from './Parse';
export class ParseUserInput extends Parse {
    constructor(parent) {
        super(parent);
    }
    get givenString() {
        return this.comparer.userInput;
    }
}
